module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("DLP安装指南 for mac")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("MAC终端包安装完成后会重启操作系统，请勿在安装过程中升级操作系统~")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic14.png"),
      "width": "850px",
      "height": "200px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic15.png"),
      "width": "850px",
      "height": "330px"
    }
  }), _c('br'), _vm._v("\n    一、软件安装"), _c('br'), _vm._v("\n    二、绑定用户名"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "color": "red"
    }
  }, [_vm._v("一、软件安装")]), _c('br'), _vm._v("\n  解压文件， 双击安装包MTDLP.pkg，若弹出一下窗口："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic1.png"),
      "width": "500px",
      "height": "230px"
    }
  }), _c('br'), _vm._v("\n  则打开 “系统偏好设置” -“安全性与隐私”，选择“通用”，点击 “仍要打开”。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic2.png"),
      "width": "500px",
      "height": "450px"
    }
  }), _c('br'), _vm._v("\n  再次双击安装包MTDLP.pkg，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic3.png"),
      "width": "380px",
      "height": "150px"
    }
  }), _c('br'), _vm._v("\n  1. 点击“继续”"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic4.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v("\n  2. 点击“继续”，并同意协议条款"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic5.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic6.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v("\n  3. 点击“继续”"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic7.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic8.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v("\n  此处密码使用"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("登录电脑系统的密码")]), _vm._v("。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic9.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic10.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "color": "red"
    }
  }, [_vm._v("二、绑定账号")]), _c('br'), _c('br'), _vm._v("\n  安装完成后 会跳出如下界面"), _c('br'), _c('br'), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic11.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("输入用户名，点击确认后，窗口会自动缩小，代表已经绑定成功了。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }, [_vm._v("安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！"), _c('br'), _vm._v("\n  如果未出现弹窗说明被系统识别mis账号，忽略此步骤（已安装却仍收到SSO消息提醒 ，解决方法详见\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.kmUrl('https://km.sankuai.com/page/19884626')
      }
    }
  }, [_vm._v("已安装却仍收到SSO消息提醒")]), _vm._v("）")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic12.png"),
      "width": "550px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic13.png"),
      "width": "600px",
      "height": "450px"
    }
  }), _c('br'), _vm._v("\n  解决方法：是因为mac系统语言使用的是英文，出现内容乱码，直接continue即可（不影响后续使用）。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("由于评论较多，可能不能及时回复，有问题可以直接大象6000或者私聊huawei02。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("软件下载地址："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "title": "https://itportal.sankuai.com/",
      "href": "https://itportal.sankuai.com/",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("https://itportal.sankuai.com/")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "30px",
      "color": "red"
    }
  }, [_vm._v("注意 ："), _c('br'), _vm._v("\n （1）账号为mis账号，请填写正确的mis账号；"), _c('br'), _vm._v("\n （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。"), _c('br'), _vm._v("\n  如：用户名：meituan ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }, [_vm._v("MAC版本安装过程TIPS："), _c('br'), _vm._v("\n  mac终端安装过程中出现如下内容乱码情况")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a681682!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataLeakInstallForMac.vue
// module id = 640
// module chunks = 1